/* ========================================
   MUSIC PLAYER - from Lovable MusicPlayer.tsx
   Global persistent playback across page navigations via sessionStorage.
   Supports up to 3 tracks (playlist), auto-advance + loop.
   ======================================== */
(function () {
  // Guard: with soft-nav the player lives outside the swapped container and must
  // init exactly once so playback stays gapless across navigations.
  if (window.__syncMusicInit) return;
  window.__syncMusicInit = true;

  var btn = document.querySelector('[data-music-player]');
  if (!btn) return;

  var audio = btn.querySelector('[data-cd-audio]');
  var disc = btn.querySelector('[data-cd-disc]');
  var badge = btn.querySelector('[data-cd-badge]');
  if (!audio || !disc) return;

  var volAttr = parseInt(btn.getAttribute('data-volume'), 10);
  audio.volume = isNaN(volAttr) ? 0.6 : Math.max(0, Math.min(100, volAttr)) / 100;
  var loopSingle = btn.getAttribute('data-loop') !== 'false';
  var playLabel = btn.getAttribute('data-label') || 'Play';

  /* ---------- Playlist ---------- */
  var raw = btn.getAttribute('data-tracks') || '';
  var tracks = raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
  if (tracks.length === 0) return;

  var STATE_KEY = 'sync:music';

  function readState() {
    try { return JSON.parse(sessionStorage.getItem(STATE_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function writeState(patch) {
    var s = readState();
    for (var k in patch) { s[k] = patch[k]; }
    try { sessionStorage.setItem(STATE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  var state = readState();
  var idx = typeof state.idx === 'number' && state.idx < tracks.length ? state.idx : 0;

  function loadTrack(i, autoplay, seekTo) {
    idx = i;
    audio.src = tracks[i];
    if (seekTo) {
      audio.addEventListener('loadedmetadata', function once() {
        try { audio.currentTime = seekTo; } catch (e) {}
        audio.removeEventListener('loadedmetadata', once);
      });
    }
    if (autoplay) {
      var p = audio.play();
      if (p && p.catch) p.catch(function () { reflect(false); });
    }
    writeState({ idx: i });
  }

  /* ---------- UI reflect ---------- */
  function setBadge(text) {
    if (!badge) return;
    if (badge.textContent === text) return;
    badge.classList.add('is-changing');
    setTimeout(function () {
      badge.textContent = text;
      badge.classList.remove('is-changing');
    }, 160);
  }

  function reflect(playing) {
    disc.classList.toggle('cd-spin', playing);
    setBadge(playing ? 'Playing' : 'Play');
    btn.setAttribute('aria-label', playing ? 'Pause music' : 'Play music');
    writeState({ playing: playing });
  }

  /* ---------- Toggle ---------- */
  btn.addEventListener('click', function () {
    if (audio.paused) {
      var p = audio.play();
      if (p && p.then) {
        p.then(function () { reflect(true); }).catch(function () { reflect(false); });
      } else {
        reflect(true);
      }
    } else {
      audio.pause();
      reflect(false);
    }
  });

  audio.addEventListener('play', function () { reflect(true); });
  audio.addEventListener('pause', function () { reflect(false); });

  /* ---------- Persist position periodically ---------- */
  audio.addEventListener('timeupdate', function () {
    writeState({ time: audio.currentTime, idx: idx });
  });

  /* ---------- Auto-advance playlist (or loop single) ---------- */
  audio.addEventListener('ended', function () {
    if (tracks.length > 1) {
      var next = (idx + 1) % tracks.length;
      loadTrack(next, true, 0);
    } else {
      audio.currentTime = 0;
      audio.play();
    }
  });

  /* ---------- Restore across navigation ---------- */
  var wasPlaying = state.playing === true;
  var resumeTime = typeof state.time === 'number' ? state.time : 0;

  loadTrack(idx, false, resumeTime);

  if (wasPlaying) {
    // Browsers may block autoplay without a gesture; try, fall back to paused UI.
    var pr = audio.play();
    if (pr && pr.then) {
      pr.then(function () { reflect(true); }).catch(function () {
        reflect(false);
        // resume on first interaction anywhere
        var resume = function () {
          audio.play().then(function () { reflect(true); }).catch(function () {});
          document.removeEventListener('click', resume);
          document.removeEventListener('touchstart', resume);
        };
        document.addEventListener('click', resume, { once: true });
        document.addEventListener('touchstart', resume, { once: true });
      });
    }
  } else {
    reflect(false);
  }
})();
